export default __webpack_public_path__ + "static/media/hero.a112deb8.jpg";